import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { styles as flexBoxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { ButtonColor, ButtonType } from '../../../ui/gzIconButton/types';
import { registerStyles, unsafeCSS } from '@vaadin/vaadin-themable-mixin/register-styles';
import { styles as vaadinGridStyles } from '../view/grid-view-styles.scss';
import { FontSizes } from '../../../types/common/types';

export const templateGridView = document.createElement('template');

// register these styles in the shadowRoot of vaadin-grid
registerStyles('vaadin-grid', unsafeCSS(`${vaadinGridStyles}`), { moduleId: 'grid-view-styles' });

templateGridView.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${textHelpersStyles}</style>
  <style>${flexBoxHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styleHelpers}</style>
  <style>${styles}</style>

  <section class="wrapper">
    <header>
      <div class="grid-header__toolbar is-disabled" id="gridToolbar" part="gridToolbar">
        <gz-grid-view-title class="grid-header__title" id="gridHeaderTitle"></gz-grid-view-title>
        <slot name="grid-header-title-status-slot"></slot>

        <div class="grid-header-actions">
          <div class="grid-header-actions__smart-view-actions">
            <div id="smartViewsActions" class="hidden">
              <div class="action">
                <gz-button id="saveViewButton" type="quiet" color="secondary" buttonheight="small" buttonfontsize="small" lowercase></gz-button>
              </div>
              <div class="action">
                <gz-button id="saveViewAsButton" type="quiet" color="secondary" buttonheight="small" buttonfontsize="small" lowercase></gz-button>
              </div>
            </div>

            <div class="action">
              <gz-button id="discardViewChanges" type="quiet" color="secondary" buttonheight="small" buttonfontsize="small" lowercase>
                </gz-button>
            </div>
          </div>
          <div class="grid-header-actions__toolbar-actions">
          <slot name="grid-header-actions-toolbar-slot"></slot>
          <div class="action favorite-button-container">
            <gz-tooltip id="favoriteIconTooltip">
            <gz-icon-button
                buttontype=${ButtonType.SQUARE}
                buttoncolor=${ButtonColor.SECONDARY}
                id="favoriteIcon"
                icon="ds-icon-favorites-star_outline"
                size="24"
                fontSize="18"
                >
            </gz-icon-button>
           </gz-tooltip>
          </div>
            <gz-tooltip class="csv-export" id="csvExportTooltip">
              <gz-icon-button
                icon="ds-icon-export"
                id="csvExportButton"
                buttontype=${ButtonType.SQUARE}
                buttoncolor=${ButtonColor.SECONDARY}
                fontsize="20"
              ></gz-icon-button>
            </gz-tooltip>

            <gz-icon-button
                id="toggleFiltersVisibility"
                class="toggle-grid-filters"
                icon="ds-icon-filter_applied"
                size="24"
                fontsize="20"
                buttontype="square"
                buttonfill="quiet"
                buttoncolor="secondary">
            </gz-icon-button>

            <gz-icon-button
                id="gridSettingsMenuTrigger"
                class="toggle-grid-settings"
                icon="ds-icon-settings"
                size="24"
                fontsize="20"
                buttontype="square"
                buttonfill="quiet"
                buttoncolor="secondary">
            </gz-icon-button>

            <gz-icon-button
                id="toolbarActionsRefresh"
                class="toolbar-actions__refresh"
                icon="ds-icon-refresh"
                size="24"
                fontsize="20"
                buttontype="square"
                buttonfill="quiet"
                buttoncolor="secondary">
            </gz-icon-button>
          </div>
        </div>
      </div>

      <div class="grid-header__info-box" id="gridInfoBox" part="gridInfoBox">
        <slot name="grid-header-infobox-slot"></slot>
      </div>

      <div class="grid-header__global-actions is-disabled" id="gridGlobalActions" part="gridGlobalActions">
        <slot name="grid-header-actions-slot"></slot>
      </div>

      <div class="filters-wrapper is-disabled" id="filtersWrapper">
        <div class="columns-loader">
          <gz-loader columns="7" lastColumnPixelWidth="184"></gz-loader>
        </div>
        <gz-grid-filters class="grid-filters"></gz-grid-filters>
      </div>
    </header>

    <section class="grid-wrapper">
      <vaadin-grid class="grid" theme="no-border" column-reordering-allowed></vaadin-grid>

      <div class="no-results">
        <gz-image-repo state="empty">
          <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight="500" class="no-results--message"></gz-title>
        </gz-image-repo>
        <slot class="no-results-additional-data" name="no-results--additional-data"></slot>
      </div>

      <gz-image-repo state="error" class="data-loading-error">
          <gz-text fontSize="14" fontWeight="400" class="data-loading-error--message"></gz-text>
      </gz-image-repo>

      <div class="rows-loader">
        <gz-loader rows="9" columns="5" splitRowsByLine lastColumnPixelWidth="72"></gz-loader>
      </div>

      <gz-progress-spinner class="data-loader" spinnerwidth="large"></gz-progress-spinner>
    </section>

    <footer class="footer-wrapper">
      <gz-grid-footer class="is-disabled" hideGridRefresh></gz-grid-footer>
    </footer>
  </section>
`;
